module.exports = __webpack_public_path__ + "static/media/71vHUG-oPOL._SL1500_.4e597fb7.jpg";